import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

const events = new Map([
  ['gtm-featured-item', 'clickFeaturedItem'],
  ['gtm-list-item', 'clickListItem'],
]);

export const onDatalayer = ({ target }: OnDatalayerProps) => {
  const documentHeadline = target?.innerText || '';

  const key = Array.from(events.keys()).find((k: string) => target?.classList.contains(k)) || '';
  const event = events.get(key);
  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;

  if (!documentHeadline || !event) {
    return undefined;
  }

  return {
    event,
    eventCategory: 'News',
    documentHeadline,
    ...(variantName && { variant_name: variantName }),
  };
};
